import { ImageResourceModel, publicConfig } from '@lerna-core';

export const getFaviconSrc = (imageResource: ImageResourceModel): string =>
  `${publicConfig?.BASE_PROTOCOL}//${imageResource.server}.${publicConfig?.MEDIA_DOMAIN}/ico/${imageResource.entity}${imageResource.path}/${imageResource.filename}`;
